var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3565 13.796C11.1041 14.2166 10.8517 14.6162 10.5994 14.9948C12.387 15.3943 13.4175 16.1094 13.4175 16.6351C13.4175 17.4343 11.062 18.633 7.3817 18.633C3.70137 18.633 1.34595 17.4553 1.34595 16.6351C1.34595 16.0883 2.37645 15.3943 4.16404 14.9948C3.91167 14.6162 3.65931 14.2166 3.40694 13.796C1.43007 14.3218 0 15.2892 0 16.6562C0 18.8433 3.7224 20 7.3817 20C11.041 20 14.7634 18.8644 14.7634 16.6562C14.7634 15.2892 13.3123 14.3218 11.3565 13.796Z",
    fill: "#D62D20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13878 16.1725C9.67401 14.0694 12.9968 9.1062 12.9968 5.61514C12.9968 2.52366 10.4732 0 7.38168 0C4.2902 0 1.76654 2.50263 1.76654 5.61514C1.76654 9.12724 5.08936 14.0694 6.62459 16.1725C7.00313 16.6982 7.76023 16.6982 8.13878 16.1725ZM4.68978 5.59411C4.68978 4.10095 5.90955 2.88118 7.40271 2.88118C8.89588 2.88118 10.1156 4.10095 10.1156 5.59411C10.1156 7.08728 8.89588 8.30704 7.40271 8.30704C5.90955 8.30704 4.68978 7.08728 4.68978 5.59411Z",
    fill: "#D62D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.69f321f89dfbba7e5f57acb9b29262dd.svg";
export { ForwardRef as ReactComponent };